import { render, staticRenderFns } from "./root.html?vue&type=template&id=bbd6eaaa&"
import script from "./root.js?vue&type=script&lang=js&"
export * from "./root.js?vue&type=script&lang=js&"
import style0 from "./root.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports